import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-heading text-2xl font-semibold">KBC Psychotherapy</h3>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Psychoanalytic psychotherapy for adults navigating trauma, 
              emotional distress, and the search for deeper self-understanding.
            </p>
            <p className="text-primary-foreground/60 text-xs">
              Kátia Aisha Belo Cardoso<br />
              BACP Registered (MBACP) #410538
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/psychotherapy" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-psychotherapy-link">
                  Psychoanalytic Psychotherapy
                </Link>
              </li>
              <li>
                <Link to="/services/trauma" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-trauma-link">
                  Trauma & Abuse Recovery
                </Link>
              </li>
              <li>
                <Link to="/services/couples" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-couples-link">
                  Couples Therapy
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-consultation-link">
                  Initial Consultation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-sm text-primary-foreground/80">
                <Mail className="h-4 w-4" />
                <a href="mailto:katia@kbcpsychotherapy.com" className="hover:text-primary-foreground transition-colors">
                  katia@kbcpsychotherapy.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm text-primary-foreground/80">
                <MapPin className="h-4 w-4 mt-0.5" />
                <span>Central London & Clapham<br />Online: UK & International</span>
              </li>
            </ul>
            <p className="text-xs text-primary-foreground/60">
              Therapy in English, Portuguese, Spanish & French
            </p>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium">Information</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-about-link">
                  About Me
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
              <li>
                <span className="text-sm text-primary-foreground/80">
                  GDPR Compliant
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20 text-center">
          <p className="text-sm text-primary-foreground/60">
            © {new Date().getFullYear()} KBC Psychotherapy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
